// extracted by mini-css-extract-plugin
export default {"tableWrapper":"UserManagementEventLoggingTemplate_tableWrapper__xKnDi"};